<template lang="pug">
  .b-comment
    ._header
      UserAvatar._author-img(:user="comment.author")
      ._author-name {{ authorName }}
      ._date {{ createdAt }}
      ._date.-edited {{ updatedAt }}
      ._reply
        CommentReplyTile(:to="comment.replyTo" @click="$emit('scrollToComment', comment.replyTo['@id'])" reverse)
      EllipsisMenu._ellipsis(:items="ellipsisMenuItems")
    BaseText._text(v-if="comment.info && comment.info.text" v-html="comment.info.text")
    FileList._files(v-if="comment.projectFiles.length" :files="comment.projectFiles" downloadAll zoom)
    ._replies(v-if="replies.length")
      CommentReplyTile(v-for="reply in replies" :key="reply['@id']" :to="reply" @click="$emit('scrollToComment', reply['@id'])")
</template>

<script>
import utils from '@/utils/common';

import FileList from '@/components/FileList.vue';
import EllipsisMenu from '@/components/EllipsisMenu.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import CommentReplyTile from '@/components/CommentReplyTile.vue';
import BaseText from '@/components/BaseText.vue';

export default {
  name: 'CommentTile',
  components: { UserAvatar, EllipsisMenu, FileList, CommentReplyTile, BaseText }, // eslint-disable-line
  props: {
    comment: Object,
    editable: Boolean,
  },
  computed: {
    authorName() { return utils.getUserName(this.comment.author); },
    createdAt() { return utils.convertDateToString(this.comment.createdAt, 'short', true, false); },
    updatedAt() { return this.comment.updatedAt ? `ред. в ${utils.convertDateToString(new Date(this.comment.updatedAt), 'short', true, false)}` : ''; },
    replies() { return this.comment.replies.filter((item) => !item.isDraft); },
    ellipsisMenuItems() {
      const items = [];

      if (this.editable) {
        items.push({ text: 'Ответить', icon: 'reply', handler: this.onReply });
      }

      items.push({ text: 'Ссылка на комментарий', icon: 'reply', handler: this.onCopyUrl });

      const outdated = new Date() - this.comment.createdAt > 60 * 60 * 24 * 1000;
      if (this.editable && !outdated && this.$store.state.auth.user.id === this.comment.author.id) {
        items.push({ text: 'Редактировать', icon: 'edit', handler: this.onEdit });
        items.push({ text: 'Удалить', icon: 'trash', handler: this.onDelete });
      }

      return items;
    },
  },
  methods: {
    onEdit() { this.$emit('edit'); },
    onDelete() { this.$emit('delete'); },
    onReply() { this.$emit('reply'); },
    onCopyUrl() {
      const { origin, pathname } = document.location;
      const url = `${origin}${pathname}?comment=${this.comment.id}`;
      navigator.clipboard.writeText(url);
      this.$push({ text: 'Ссылка скопирована в буфер обмена' });
    },
  },
};
</script>

<style scoped lang="scss">
.comment {
  display: flex;
  flex-direction: column;
  gap: 22px;
  position: relative;
  padding: 10px 20px 20px;
  background: #F5F7F9;
  border-radius: 12px;

  &__header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 20px;
  }

  &__author-img {
    width: 40px;
    height: 40px;
  }

  &__author-name {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #33A1FB;
  }

  &__text {
    padding: 0;
    background: #F5F7F9;
  }

  &__replies {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  &__date {
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__ellipsis {
    margin-left: auto;
    opacity: 0;
  }

  &:hover &__ellipsis {
    opacity: 1;

    &:hover:before {
      display: none;
    }
  }

  @media (min-width: 900px) {
    margin-left: 53px;

    &__author-img {
      position: absolute;
      top: 0;
      left: -53px;
    }
  }

  @media (max-width: 1700px) {
    &__header {
      display: grid;
      grid-template-columns: max-content max-content 1fr;
      column-gap: 20px;
      row-gap: 0;
    }

    &__date {
      grid-row: 2;
    }

    //&__reply, &__ellipsis {
    //  grid-row: 1 / 2 span;
    //  opacity: 1;
    //}

    &__ellipsis {
      opacity: 1;
    }

    &__reply::v-deep {
      .answer {
        display: none;
      }
    }
  }

  @media (max-width: 900px) {
    &__header {
      grid-template-columns: max-content minmax(auto, max-content) 1fr;
      align-items: center;
      column-gap: 10px;
    }

    &__author-img {
      grid-row: 1 / 2 span;
    }

    &__date {
      grid-column: 2;
      grid-row: 2;

      &--edited {
        grid-column: 3;
      }
    }

    &__reply {
      grid-row: 3;
      grid-column: 1 / 3 span;
      margin-top: 15px;

      //&::v-deep .answer {
      //  display: block;
      //}
    }

    &__ellipsis {
      grid-column: 3;
    }
  }
  @media (max-width: 576px) {
    &__date {
      &--edited {
        grid-column: 2;
        grid-row: 3;
      }
    }
  }
}
</style>
